import React from 'react'
import { Authentication, Cart, Home,  WebShop, Orders} from './screens'
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom'
import { Navbar, Footer, MyWork, AboutMe, Resources, ContactMe } from './sections'
import AuthState from './context/AuthState'
import CartProvider from './context/CartContext'
function App() {
  return (
    <Router>
      <AuthState>
        <CartProvider>
          <Navbar />
          <main style={{minHeight:'70vh'}}>
            <Routes>
              <Route path='/' element={<Home />}/>
              <Route path='/AboutMe' element={<AboutMe />}/>
              <Route path='/MyWork' element={<MyWork />}/>
              <Route path='/Resources' element={<Resources />}/>
              <Route path='/ContactMe' element={<ContactMe />}/>
              <Route path='/Authentication' element={<Authentication />}/>
              <Route path='/WebShop' element={<WebShop />}/>
              <Route path='/Cart' element={<Cart />}/>
              <Route path='/Orders' element={<Orders />}/>
              <Route path='*' element={<Home />}/>
            </Routes>
          </main>
          <Footer />
        </CartProvider>
      </AuthState>
    </Router>
  )
}

export default App